module.exports = __webpack_public_path__ + "media/images/country_flags/ni-95c4b3affeaa6a276897f83ebd5aeb74.png";